import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'

/**
 * Render allauth error arrays.
 * Allauth returns errors as: { errors: [{ message: "...", code: "...", param: "..." }] }
 */
const FormErrors = ({ errors }) => {
    if (!errors || errors.length === 0) return null

    return (
        <Box sx={{ mb: 2 }}>
            {errors.map((error, index) => (
                <Alert key={index} severity="error" sx={{ mb: 1 }}>
                    {error.message || error}
                </Alert>
            ))}
        </Box>
    )
}

export default FormErrors
